'use client';

import React from 'react';
import { trackClick } from '../../utilities/track-click';
import { useAnalyticsTenantId } from './analytics-context';

/**
 * Client wrapper that fires a click analytics beacon on click.
 *
 * Used by `renderButtonBlock` when `isCta` is true. Wraps the rendered
 * block view component and intercepts clicks without preventing default
 * navigation behaviour.
 */
export const TrackedButton: React.FC<{
  clickType: string;
  destination: string;
  label?: string;
  isConversion?: boolean;
  children: React.ReactNode;
}> = ({ clickType, destination, label, isConversion, children }) => {
  const tenantId = useAnalyticsTenantId();

  if (!tenantId) return <>{children}</>;

  return (
    <span
      onClick={() => trackClick(tenantId, clickType, destination, { label, isConversion })}
      style={{ display: 'contents' }}
    >
      {children}
    </span>
  );
};
